import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SiteHeader from './SiteHeader';
import { VERSION_STRING } from '../../version';

interface ReviewerLayoutProps {
  children: ReactNode;
}

export default function ReviewerLayout({ children }: ReviewerLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const displayName = user?.email?.split('@')[0] ?? 'Bíráló';
  const initials    = displayName.slice(0, 1).toUpperCase();

  const navItems = [
    {
      path: '/reviewer/applications',
      label: 'Hozzárendelt pályázatok',
      icon: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      ),
    },
  ];

  return (
    <div className="app-shell">
      <SiteHeader roleLabel="Bíráló" />

      <div className="app-body">
        <aside className="app-sidebar">
          <div style={{ padding: '14px 16px 6px' }}>
            <span className="badge badge-neutral" style={{ fontSize: 11, letterSpacing: '.06em' }}>
              BÍRÁLÓ
            </span>
          </div>

          <nav style={{ padding: '8px 12px 0', display: 'flex', flexDirection: 'column', gap: 2 }}>
            {navItems.map((item) => (
              <button
                key={item.path}
                className={`nav-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
                onClick={() => navigate(item.path)}
              >
                {item.icon}
                {item.label}
              </button>
            ))}
          </nav>

          <div style={{ flex: 1 }} />

          <div style={{ padding: '6px 16px 4px', textAlign: 'center' }}>
            <span style={{ fontSize: 10, color: 'var(--muted-foreground)', fontFamily: 'monospace', letterSpacing: '.04em' }}>
              {VERSION_STRING}
            </span>
          </div>

          <div style={{ padding: '10px 16px 14px', borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: 'var(--primary)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 12, flexShrink: 0,
            }}>{initials}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary)' }}>{displayName}</div>
              <div style={{ fontSize: 11, color: 'var(--muted-foreground)' }}>Bíráló</div>
            </div>
          </div>
        </aside>

        <main className="app-main">{children}</main>
      </div>
    </div>
  );
}
